export default {
  setHospitalConfig(state, payload) {
    const prevUrl = state.hospitalConfig?.logoUrl
    if (typeof prevUrl === 'string' && prevUrl.startsWith('blob:')) {
      try {
        URL.revokeObjectURL(prevUrl)
      } catch {
        /* ignore */
      }
    }
    state.hospitalConfig = payload
  },
  setLoadedFromApi(state, value) {
    state.loadedFromApi = !!value
  },
}
